import { DateTime } from 'luxon'

export class FilterDefinition {
  #filter = null
  #definition = null
  #summary = null
  #info = null

  constructor(definition) {
    this.#definition = definition
    this.#filter = JSON.parse(definition?.definitionJson || '{}')
    this.#summary = this.#createSummary(this.#filter)
    this.#info = this.#createInfo(this.#summary)
  }

  get externalId() {
    return this.#definition.externalId
  }

  get createdTimestamp() {
    return this.#definition.createdTimestamp
  }

  get lastModifiedTimestamp() {
    return this.#definition.lastModifiedTimestamp
  }

  get status() {
    return this.#definition.status
  }

  get createdBy() {
    return this.#definition.createdBy
  }

  get lastModifiedBy() {
    return this.#definition.lastModifiedBy
  }

  get personal() {
    return this.#definition.personal
  }

  get name() {
    return this.#definition.name
  }

  get uri() {
    return this.#definition.uri
  }

  get description() {
    return this.#definition.description
  }

  get definitionJson() {
    return this.#definition.definitionJson
  }

  get filter() {
    return this.#filter
  }

  get summary() {
    return this.#summary
  }

  get info() {
    return this.#info
  }

  #createSummary(filters) {
    const result = {}
    Object.keys(filters)
      .filter((d) => d !== 'externalIds')
      .map((key) => {
        const values = filters[key]
        if (Array.isArray(values) && values.length > 0) {
          const name = (key.startsWith('selected') ? key.substring(8) : key)
            .replace(/[A-Z]/g, ' $&')
            .trim()
            .toLowerCase()
          result[name] = values.length
        } else if (key === 'period' || key === 'startTimestamp' || key === 'endTimestamp') {
          if (filters.period === 'CUSTOM') {
            const from = DateTime.fromISO(filters.startTimestamp).toLocal().toISO()?.replace('T', ' ') || ''
            const to = DateTime.fromISO(filters.endTimestamp).toLocal().toISO()?.replace('T', ' ') || ''
            if (from && to) result.period = '(From ' + from + ' to ' + to + ')'
            else if (from && !to) result.period = '(Since ' + from + ')'
            else if (!from && to) result.period = '(Upto ' + to + ')'
            else result.period = ''
          } else if (key !== 'startTimestamp' && key !== 'endTimestamp') {
            result[key] = values?.toLowerCase().replaceAll('_', ' ')
          }
        } else if (
          key !== 'period' &&
          key !== 'startTimestamp' &&
          key !== 'endTimestamp' &&
          typeof filters[key] !== 'object'
        ) {
          result.others = true
        }
        return result
      })
    return result
  }

  #createInfo(summary) {
    let filter = 'Filtering On '
    const keys = Object.keys(summary)
    keys
      .filter((d) => d !== 'others' && d !== 'period')
      .forEach((key) => {
        filter += `${summary[key]} ${key} `
      })
    if (summary.others) filter += 'and others '
    if (summary.period) filter += summary.period
    return keys.length > 0 ? filter : ''
  }
}
